import(/* webpackMode: "eager" */ "/app/admin/src/app/super-admin/page.tsx");
